var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-list',{attrs:{"endpoint":"grupo-pontuacao-professor","rota-base":"/admin/grupo-pontuacao-professor","titulo":"GRUPOS DE PONTUAÇÃO DE PROFESSOR","titulo-singular":"Grupo de Pontuação de Professor","colunas-extras":[{"campo":"descricao","label":"Descrição","tipo":"text","span":24}]}})
}
var staticRenderFns = []

export { render, staticRenderFns }